import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20editorial%20background%2C%20warm%20crimson%20and%20deep%20amber%20gradient%20with%20soft%20out%20of%20focus%20bokeh%20lights%2C%20dark%20elegant%20atmosphere%20with%20subtle%20light%20rays%2C%20magazine%20cover%20aesthetic%2C%20rich%20textured%20overlay%2C%20luxurious%20cinematic%20mood%2C%20no%20text%20no%20people%2C%20abstract%20dramatic%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜爆料背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium mb-4 border border-primary-500/30">
              吃瓜第一站 · 新鲜热瓜一网打尽
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
              {siteInfo.name} — 全网八卦第一站
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-white/75 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); handleScroll('#updates'); }}
                className="whitespace-nowrap px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer text-sm md:text-base"
              >
                立即吃瓜
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleScroll('#topics'); }}
                className="whitespace-nowrap px-8 py-3 border border-white/30 text-white font-medium rounded-md hover:bg-white/10 transition-colors cursor-pointer text-sm md:text-base"
              >
                探索话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20magazine%20cover%20style%20abstract%20composition%2C%20layered%20warm%20crimson%20and%20golden%20amber%20geometric%20shapes%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20luxurious%20textured%20background%2C%20elegant%20and%20mysterious%20mood%2C%20premium%20editorial%20aesthetic%2C%20vertical%20magazine%20layout%20feel%2C%20no%20text%20no%20people%2C%20high%20end%20fashion%20magazine%20quality&width=600&height=800&seq=hero-visual-main&orientation=portrait"
                alt="吃瓜爆料主视觉"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}